module.exports = __webpack_public_path__ + "408b21df782b02ac68dff7f667094924.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/linkCard/whatsaynew.jpg
// module id = 77mg
// module chunks = 0